// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyDK8ocuPI83aUshq6iu2zmj1qbyrmdd3ME",
    authDomain: "phlenu-delivery.firebaseapp.com",
    databaseURL: "https://phlenu-delivery.firebaseio.com",
    projectId: "phlenu-delivery",
    storageBucket: "phlenu-delivery.appspot.com",
    messagingSenderId: "325976906645",
    appId: "1:325976906645:web:f2aa4c0c54986788d8b49c",
    measurementId: "G-8M8G34XLS6"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
